import { on } from "@ngrx/store";
import { ApplicationStore } from "../application.state";
import { DataActions } from "./data.actions";

// Feature reducers
import { currenciesReducer } from "./currency/currencies/currencies.reducer";
import { deliveryTermsReducer } from "./delivery-term/delivery-terms/delivery-terms.reducer";
import { paymentTermsReducer } from "./payment-term/payment-terms/payment-terms.reducer";
import { interestRatesReducer } from "./interest-rate/interest-rates/interest-rates.reducer";
import { financingCompaniesReducer } from "./financing-company/financing-companies/financing-companies.reducer";
import { salesCreditRolesReducer } from "./sales-credit-role/sales-credit-roles/sales-credit-roles.reducer";
import { ecoLabelsReducer } from "./eco-label/eco-labels/eco-labels.reducer";
import { unspscsReducer } from "./unspsc/unspscs/unspscs.reducer";
import { brandsReducer } from "./brand/brands/brands.reducer";
import { categoriesReducer } from "./category/categories/categories.reducer";
import { locationsReducer } from "./location/locations/locations.reducer";
import { contractTypesReducer } from "./contract-type/contract-types/contract-types.reducer";
import { catalogTypesReducer } from "./catalog-type/catalog-types/catalog-types.reducer";
import { subscriptionConceptsReducer } from "./subscription-concept/subscription-concepts/subscription-concepts.reducer";
import { salesPersonsReducer } from "./sales-person/sales-persons/sales-persons.reducer";
import { salesSupportPersonsReducer } from "./sales-support-person/sales-support-persons/sales-support-persons.reducer";
import { countriesReducer } from "./country/countries/countries.reducer";
import { creditCheckReducer } from "./credit-check/credit-check.reducer";
import { creditChecksReducer } from "./credit-check/credit-checks/credit-checks.reducer";
import { customerTypesReducer } from "./customer-type/customer-types/customer-types.reducer";

// **************************************************************************
// DATA REDUCER (array format for spreading in parent)
// **************************************************************************

// Initialize data action (dispatches all feature load actions via effects)
const initializeData = on(DataActions.initializeData, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        error: null,
        loading: true,
    },
}));

const initializeDataFailure = on(DataActions.initializeDataFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        loading: false,
    },
}));

export const dataReducer = [
    // Root data actions
    initializeData,
    initializeDataFailure,
    // Feature reducers
    ...currenciesReducer,
    ...deliveryTermsReducer,
    ...paymentTermsReducer,
    ...interestRatesReducer,
    ...financingCompaniesReducer,
    ...salesCreditRolesReducer,
    ...ecoLabelsReducer,
    ...unspscsReducer,
    ...brandsReducer,
    ...categoriesReducer,
    ...locationsReducer,
    ...contractTypesReducer,
    ...catalogTypesReducer,
    ...subscriptionConceptsReducer,
    ...salesPersonsReducer,
    ...salesSupportPersonsReducer,
    ...countriesReducer,
    ...creditCheckReducer,
    ...creditChecksReducer,
    ...customerTypesReducer,
];
